import * as React from 'react';

import { get as userGet } from 'js/lib/user';

import { useConsumerMyPageHeader } from 'bundles/composable-page-header-consumer/contexts/ConsumerMyPageHeaderContext';
import DegreeLearnerOnConsumerMobileMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/mobile/DegreeLearnerOnConsumerMobileMainNav';
import EnterpriseLearnerOnConsumerMobileMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/mobile/EnterpriseLearnerOnConsumerMobileMainNav';
import LoggedInConsumerWithMetaNavLinksMobileMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/mobile/LoggedInConsumerWithMetaNavLinksMobileMainNav';
import LoggedOutConsumerMobileMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/mobile/LoggedOutConsumerMobileMainNav';
import { useIsOrgScopedHome } from 'bundles/unified-common/hooks/useIsOrgScopedHome';

import OrgScopedEnterpriseLearnerOnConsumerMobileMainNav from './OrgScopedEnterpriseLearnerOnConsumerMobileMainNav';

const AccountPageMobileMainNav = () => {
  const { chosenEnterpriseProgram, chosenDegree, naptimeChosenOrganization } = useConsumerMyPageHeader();
  const user = userGet();
  const isOrgScoped = useIsOrgScopedHome();

  const getMobileNav = () => {
    if (user?.id && isOrgScoped && !!naptimeChosenOrganization) {
      return OrgScopedEnterpriseLearnerOnConsumerMobileMainNav;
    } else if (user?.id && !!chosenDegree) {
      return DegreeLearnerOnConsumerMobileMainNav;
    } else if (user?.id && !!chosenEnterpriseProgram) {
      return EnterpriseLearnerOnConsumerMobileMainNav;
    } else if (user?.id) {
      return LoggedInConsumerWithMetaNavLinksMobileMainNav;
    } else {
      return LoggedOutConsumerMobileMainNav;
    }
  };

  const MobileNavComponent = getMobileNav();

  return <MobileNavComponent />;
};

export default AccountPageMobileMainNav;
